// Shared helpers for agent Dashboard + Followups pages

// Haversine distance in km between two {lat, lng} points
export function haversineKm(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const toRad = (d) => (d * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function fmtDistance(km) {
  if (km == null || isNaN(km)) return null;
  if (km < 1) return `${Math.round(km * 1000)} m`;
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}

// Severity tier for an overdue follow-up: 'mild' (<=3d), 'mid' (4-7d), 'severe' (>7d)
export function overdueTier(days) {
  const d = Number(days) || 0;
  if (d <= 0) return null;
  if (d <= 3) return 'mild';
  if (d <= 7) return 'mid';
  return 'severe';
}

export function overdueTierStyle(tier) {
  // Inline style mapping so we don't have to introduce CSS classes everywhere
  if (tier === 'mild') return { background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047' };
  if (tier === 'mid') return { background: '#ffedd5', color: '#9a3412', border: '1px solid #fdba74' };
  if (tier === 'severe') return { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' };
  return {};
}

// Pretty relative-time for past dates: "today", "yesterday", "3 days ago", "Mar 12"
export function relativePast(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;
  const today = new Date(new Date().toDateString());
  const that = new Date(new Date(d).toDateString());
  const diff = Math.floor((today - that) / 86400000);
  if (diff < 0) return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  if (diff === 0) return 'today';
  if (diff === 1) return 'yesterday';
  if (diff < 30) return `${diff}d ago`;
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

// Extract latest visit log entry (most recent by visitedAt/addedAt)
export function latestVisit(log) {
  if (!Array.isArray(log) || log.length === 0) return null;
  // Try sorting by date; fallback to last array element
  const sorted = [...log].sort((a, b) => {
    const da = new Date(a.visitedAt || a.addedAt || 0).getTime();
    const db = new Date(b.visitedAt || b.addedAt || 0).getTime();
    return db - da;
  });
  return sorted[0];
}

// Truncate text for compact display
export function truncate(s, n = 60) {
  if (!s) return '';
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
}
